import { Typography } from '@mui/material';
import { FC, useState } from 'react';

import CustomButton from 'components/CustomButton';
import EditOrderModal from 'containers/PosOrderDetailsPage/OrderHeader/EditOrderModal';

import {
  HeaderContent,
  OrderStatus,
} from './index.styled';

interface OrderHeaderProps {
  orderId: number | string;
  status: string;
  onExitClick: () => void;
}

const OrderHeader: FC<OrderHeaderProps> = ({
  orderId,
  status,
  onExitClick,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <HeaderContent>
      <CustomButton
        id="button-edit"
        variant="outlined"
        size="small"
        sx={{ mb: 2 }}
        onClick={handleOpenModal}
      >
        Edit
      </CustomButton>

      <OrderStatus>
        <Typography variant="h5">
          {`Order ${orderId}`}
        </Typography>
        <Typography>
          {`Status: ${status}`}
        </Typography>
      </OrderStatus>

      <CustomButton
        id="button-exit"
        variant="contained"
        size="small"
        onClick={onExitClick}
        sx={{ mb: 2 }}
      >
        Exit
      </CustomButton>

      <EditOrderModal
        open={openModal}
        handleCloseModal={handleCloseModal}
      />
    </HeaderContent>
  );
};

export default OrderHeader;
